@for (data of datas; track data) {
  <li>
    <a href="/artigos-por-data/{{data.ano}}/{{data.mes}}/{{data.idTema}}">{{toString(data.mes)}}/{{data.ano}}</a>
  </li>
}
